import { render, staticRenderFns } from "./entity-lock-info.vue?vue&type=template&id=39531b3e&"
import script from "./entity-lock-info.vue?vue&type=script&lang=js&"
export * from "./entity-lock-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports